import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon, MailIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="bg-white shadow-md" data-id="element-131">
      <div className="container mx-auto px-4 py-2" data-id="element-132">
        {/* Top bar with contact info */}
        <div className="hidden md:flex justify-end items-center space-x-4 py-2 text-sm text-gray-600" data-id="element-133">
          <div className="flex items-center" data-id="element-134">
            <PhoneIcon size={16} className="mr-1" data-id="element-135" />
            <span data-id="element-136">00965 99886331</span>
          </div>
          <div className="flex items-center" data-id="element-137">
            <MailIcon size={16} className="mr-1" data-id="element-138" />
            <span data-id="element-139">george@forsatours.com</span>
          </div>
        </div>
        {/* Main header with logo and navigation */}
        <div className="flex justify-between items-center py-4" data-id="element-140">
          <Link to="/" className="flex items-center" data-id="element-141">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jMrBieCLcCL3ikysvQ9VMQ/WhatsApp_Image_2025-10-08_at_12.13.32_0dc8d5a9.jpg" alt="Forsa Co. Logo" className="h-16 md:h-20" data-id="element-142" />
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-143">
            <Link to="/" className="text-gray-800 hover:text-blue-600 font-medium" data-id="element-144">
              Home
            </Link>
            <Link to="/about" className="text-gray-800 hover:text-blue-600 font-medium" data-id="element-145">
              About Us
            </Link>
            <Link to="/destinations" className="text-gray-800 hover:text-blue-600 font-medium" data-id="element-146">
              Destinations
            </Link>
            <Link to="/packages" className="text-gray-800 hover:text-blue-600 font-medium" data-id="element-147">
              Packages
            </Link>
            <Link to="/contact" className="text-gray-800 hover:text-blue-600 font-medium" data-id="element-148">
              Contact
            </Link>
          </nav>
          {/* Mobile menu button */}
          <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-gray-500 focus:outline-none" data-id="element-149">
            {isMenuOpen ? <XIcon size={24} data-id="element-150" /> : <MenuIcon size={24} data-id="element-151" />}
          </button>
        </div>
        {/* Mobile Navigation */}
        {isMenuOpen && <nav className="md:hidden py-4 bg-white" data-id="element-152">
            <div className="flex flex-col space-y-4" data-id="element-153">
              <Link to="/" className="text-gray-800 hover:text-blue-600 font-medium px-4" onClick={() => setIsMenuOpen(false)} data-id="element-154">
                Home
              </Link>
              <Link to="/about" className="text-gray-800 hover:text-blue-600 font-medium px-4" onClick={() => setIsMenuOpen(false)} data-id="element-155">
                About Us
              </Link>
              <Link to="/destinations" className="text-gray-800 hover:text-blue-600 font-medium px-4" onClick={() => setIsMenuOpen(false)} data-id="element-156">
                Destinations
              </Link>
              <Link to="/packages" className="text-gray-800 hover:text-blue-600 font-medium px-4" onClick={() => setIsMenuOpen(false)} data-id="element-157">
                Packages
              </Link>
              <Link to="/contact" className="text-gray-800 hover:text-blue-600 font-medium px-4" onClick={() => setIsMenuOpen(false)} data-id="element-158">
                Contact
              </Link>
            </div>
          </nav>}
      </div>
    </header>;
};
export default Header;